import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ErrorPage } from "@/components/error-page/ErrorPage";
import { GLOBAL_NAVIGATION_URLS, globalNavigation } from "@/utils/constants";
import { ECashierFlows, EIcon } from "@/utils/enums";
import { useLogger } from "@/hooks/useLogger";

export const TransferIsNotAvailable = ({
  reason,
}: {
  reason: "no_accounts" | "no_funds" | "request_error";
}) => {
  const logger = useLogger();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const message =
    reason === "no_accounts"
      ? t("transfer.errors.no_accounts")
      : t("transfer.errors.no_funds");

  const action = () => {
    if (reason === "no_accounts") {
      globalNavigation(GLOBAL_NAVIGATION_URLS.CREATE_TRADING_ACCOUNT);
    } else {
      navigate(`/${ECashierFlows.Deposit}`);
    }
  };
  const actionLabel =
    reason === "no_accounts"
      ? t("global.nav_buttons.add_trading_account")
      : t("deposit.title");

  if (reason === "request_error") {
    logger.error("Could not load available accounts");
    return <ErrorPage />;
  }

  return (
    <ErrorPage
      icon={EIcon.EmptyStateError}
      title={t("transfer.errors.transfer_not_available")}
      message={message}
      buttonLabel={actionLabel}
      buttonAction={action}
    />
  );
};
